<script lang="ts" setup>
interface Props {
  title?: string
  body?: string
  uid?: string
  buttons?: Button[]
  theme?: Theme
}
defineProps<Props>()
</script>

<template>
  <div
    class="px-3 md:px-6"
    :class="`bg-${theme}`"
  >
    <section
      class="flex flex-col flex-wrap p-6 mx-auto max-w-screen-xl pb-32 pt-64"
    >
      <p
        class="pb-12 text-2xl md:text-4xl lg:text-5xl header "
      >
        {{ title }}
      </p>
      <Markdown
        v-if="body"
        :md="body"
      >
        {{ body }}
      </Markdown>
      <div class="flex flex-wrap gap-3">
        <ButtonGeneral
          v-for="(button, index) in buttons"
          :key="index"
          v-bind="button"
          class="self-start mt-6 md:mt-6 lg:mt-8"
          :theme="theme"
        />
      </div>
    </section>
  </div>
</template>

<style lang="css" scoped>
</style>
